import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useOfferModel } from "../offerModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useOfferDetailModel } from "./details/offerDetailModel";

export const DataBox = () => {
    const { selectedRowKeys, exportOffer, downloadTpl, disableOffer } = useOfferModel();
    const { updateFormVal } = useOfferDetailModel(() => []);
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let offerEditKey = "2-2-2";
        let isFindNav = findNav(offerEditKey);
        if (!isFindNav) {
            addNav(offerEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "报价跳转详情",
                type: "warning",
                text: "您还有报价详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(offerEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("2-2-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.O_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.O_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    globalPrompt("modal", {
                        title: "报价单作废",
                        text: ` `,
                        onOk: () => disableOffer(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_S_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportOffer()}
        >导出</Button>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}